const objUnbinder = (_obj) => JSON.parse(JSON.stringify(_obj))

export default objUnbinder
